const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20abstract%20scene%20with%20dramatic%20nebula%20and%20star%20field%2C%20warm%20amber%20and%20deep%20space%20contrast%2C%20epic%20movie%20atmosphere%2C%20elegant%20minimalist%20style%2C%20no%20text%20no%20people&width=800&height=450&seq=media-scifi-01&orientation=landscape',
    title: '星际迷航：新纪元 — 终极预告解析',
    meta: '科幻 · 4K修复版',
    duration: '2:35',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20atmosphere%20with%20warm%20lantern%20light%20and%20ancient%20architecture%20silhouette%2C%20golden%20amber%20tones%2C%20elegant%20cinematic%20composition%2C%20minimalist%20abstract%20style%2C%20no%20text%20no%20people&width=800&height=450&seq=media-drama-02&orientation=landscape',
    title: '长安十二时辰 — 幕后制作特辑',
    meta: '古装 · 独家花絮',
    duration: '4:12',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20inspired%20abstract%20scene%20with%20flowing%20energy%20lines%20and%20warm%20coral%20sunset%20sky%2C%20dramatic%20composition%2C%20golden%20and%20rose%20color%20palette%2C%20modern%20cinematic%20style%2C%20no%20text%20no%20characters&width=800&height=450&seq=media-anime-03&orientation=landscape',
    title: '进击的巨人 — 最终季名场面回顾',
    meta: '动漫 · 高燃混剪',
    duration: '5:48',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20stage%20performance%20atmosphere%20with%20warm%20spotlight%20beams%20and%20soft%20haze%2C%20elegant%20entertainment%20show%20aesthetic%2C%20golden%20and%20amber%20tones%2C%20minimalist%20abstract%20composition%2C%20no%20text%20no%20people&width=800&height=450&seq=media-variety-04&orientation=landscape',
    title: '极限挑战第十季 — 爆笑片段合集',
    meta: '综艺 · 欢乐时刻',
    duration: '3:20',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          精彩片段
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          精选高光时刻与幕后花絮，感受光影魅力
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {mediaItems.map((m, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors group cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={m.image}
                  alt={m.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/80 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-xl text-primary-600 group-hover:text-background-50 ml-0.5 transition-colors"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-900/70 text-xs text-background-50 whitespace-nowrap">
                  {m.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-800 line-clamp-2 group-hover:text-primary-600 transition-colors mb-1">
                  {m.title}
                </h3>
                <span className="text-xs text-foreground-400">{m.meta}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}